export default __webpack_public_path__ + "static/media/closeBtn.19edcc51.svg";